import getConfig from '@ringcentral/rwc-utils/src/config';
import { OS_INFO, getOsVersion } from '@ringcentral/rwc-utils/src/client-detection';

import { METADATA } from '@ringcentral/rwc-utils/src/web-client-info';

const UNKNOWN = 'unknown';

export const getBrandName = () => getConfig('PAS')?.brandName || UNKNOWN;
export const getBrandId = () => getConfig('PAS')?.brandId || UNKNOWN;

export const getJupiterClientId = () => getConfig('PAS')?.jupiterClientId || '';

const getAppName = () => getConfig('PAS')?.userAgentAppName || UNKNOWN;

export const webClientReleaseVersion = METADATA.version || UNKNOWN;
export const webClientCommitHash = METADATA.commit.substring(0, 8) || UNKNOWN;
export const getXUserAgentWithoutAppName = () => {
    const osVersion = getOsVersion();
    return `${webClientReleaseVersion} (${getBrandName()}; ${OS_INFO}/${osVersion}; rev.${webClientCommitHash})`;
};

export const getXUserAgent = () => `${getAppName()}/${getXUserAgentWithoutAppName()}`;
